<template>
    <div>
        <div class="flex "   v-show="isRecordVisible"  >
            <el-button @click="startPauseResumeRecording" :disabled="audioUrl != null"
                        :type="isRecording ?( isPaused? 'warning':'primary'):'success'">
                <i class="fas" :class="isRecording ? (isPaused ? 'fa-play' : 'fa-pause') : 'fa-microphone'"></i>
                {{ isRecording ? (isPaused ? '继续录音' : '暂停录音') : '开始录音' }}
            </el-button>
            <el-button @click="stopOrResetRecording" :disabled="!isRecording && !audioUrl"
                        :type="audioUrl ? 'warning' : 'danger'">
                <i class="fas" :class="audioUrl ? 'fa-redo' : 'fa-stop'"></i>
                {{ audioUrl ? '重新录制' : '停止录音' }}
            </el-button>
            <audio v-if="audioUrl" :src="audioUrl" controls></audio>
            <el-button @click="downWEBM">
                下载
            </el-button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            value: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            isRecordVisible: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                },
            },
        },
        data() {
            return {
                mediaRecorder: null,
                mediaStream: null,
                audioChunks: [],
                isRecording: false,
                isPaused: false,
                audioUrl: null,                
            };
        },
        methods: {
            downWEBM() {
                if (!this.audioUrl) {
                    this.$message.info("无任何录音！");
                }
                const link = document.createElement('a');
                link.href = this.audioUrl;
                link.download = `${Date.now()}.webm`;
                link.click();
                link.remove();
            },
            async uptest(){
                // 将 audioUrl 转换为 Blob
                const response = await fetch(this.audioUrl);
                const audioBlob = await response.blob();
                const file_size = audioBlob.size; 
                console.log("111111");

                // 读取 Blob 数据为 ArrayBuffer
                const arrayBuffer = await audioBlob.arrayBuffer();
                // 计算 SHA-256 哈希值
                const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
                // 将 ArrayBuffer 转换为十六进制字符串
                const hashArray = Array.from(new Uint8Array(hashBuffer));
                const fiel_cv = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');
                const file_name = "xiaozhao_" + String(Date.now()) +".webm";
                console.log("5");
                // 创建 FormData 对象
                const formData = new FormData();
                formData.append("audio", audioBlob, file_name);
                /*formData.append("consultant_id",consultant_id);
                formData.append("visitor_id",visitor_id);
                formData.append("file_name",file_name);
                formData.append("file_size",file_size);
                formData.append("fiel_cv",fiel_cv);*/
                formData.append("consultant_id","01");
                formData.append("visitor_id","02");                
                formData.append("file_name",file_name);
                formData.append("file_size",file_size);
                formData.append("file_cv",fiel_cv);
                formData.append("edition", "# 基础版");//基础班/认知行为(CBT)/精神分析(动力学)

                try {
                    // 发送 POST 请求到服务器
                    const response = await axios.post("/api/uploadfile", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });
                    if (response.data.error_code == 0) {
                        response.data.data;
                        console.log("上传成功:" + response.data.data.summary);
                        this.$message({
                            message:"上传成功",
                            type: "success"
                        });
                    } else {
                        this.$message({
                            message: "发生错误:" + String(response.data.error_code) + "\n" + response.data.message,
                            type: "error"
                        });
                        console.log("发生错误:"+ String(response.data.error_code)+"\n" + response.data.message);
                    }
                } catch (error) {
                    console.error("上传失败:", error);
                    this.$message({
                        message: "发生错误:"+error,
                        type: "error"
                    });
                }
            },
            handleBeforeUnload(event) {
                if (this.isRecording || this.audioUrl) {
                    const confirmationMessage = '您有录音正在进行或已存在，您确定要离开吗？';
                    event.preventDefault();
                    event.returnValue = confirmationMessage;
                    return confirmationMessage;
                }
            },
            async startPauseResumeRecording() {
                if (this.isRecording) {
                    if (this.isPaused) {
                        this.mediaRecorder.resume();
                        this.isPaused = false;
                    } else {
                        this.mediaRecorder.pause();
                        this.isPaused = true;
                    }
                } else {
                    try {
                        this.mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });
                        this.mediaRecorder = new MediaRecorder(this.mediaStream);

                        this.mediaRecorder.ondataavailable = (event) => {
                            this.audioChunks.push(event.data);
                        };

                        this.mediaRecorder.onstop = () => {
                            const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
                            if (this.audioUrl) {
                                URL.revokeObjectURL(this.audioUrl);
                            }
                            this.audioUrl = URL.createObjectURL(audioBlob);
                            this.audioChunks = []; // 清空音频块
                            // 停止媒体流，释放麦克风
                            this.mediaStream.getTracks().forEach(track => track.stop());
                            this.mediaStream = null; // 清空媒体流
                        };

                        this.mediaRecorder.start();
                        this.isRecording = true;
                        this.isPaused = false;
                    } catch (error) {
                        console.error("获取麦克风权限失败:", error);
                        alert("请允许使用麦克风权限以进行录音。");
                    }
                }
            },
            stopOrResetRecording() {
                if (this.audioUrl) {
                    const confirmationMessage = '您有录音文件存在，确定要重新录制吗？';
                    if (confirm(confirmationMessage)) {
                        // 如果有录音，清空录音并重置状态
                        this.audioUrl = null;
                        this.audioChunks = [];
                        this.isPaused = false;
                        this.isRecording = false;
                    }
                } else {
                    // 如果正在录音，停止录音
                    this.mediaRecorder.stop();
                    this.isRecording = false;
                    this.isPaused = false;
                }
            },
        },
        mounted() {
            window.addEventListener('beforeunload', this.handleBeforeUnload);
        },
        beforeDestroy() {
            window.removeEventListener('beforeunload', this.handleBeforeUnload);
        },
    };
</script>
<style>

    @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');
</style>
